// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__sfDTt","subheader":"ReorderModal_subheader__2XZc8","listWrap":"ReorderModal_listWrap__2ziJ_"};